import React from "react";

const SummaryCard = ({
    title,
    value,
    color,
    icon,
    isDark
}) => {

    return (

        <div
            style={{
                background: isDark ? "#111827" : "#fff",
                border: `1px solid ${isDark ? "#1f2937" : "#e5e7eb"}`,
                borderRadius: 16,
                padding: 20,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
            }}
        >

            <div>

                <div
                    style={{
                        fontSize: 13,
                        color: "#6b7280",
                        marginBottom: 8
                    }}
                >
                    {title}
                </div>

                <div
                    style={{
                        fontSize: 28,
                        fontWeight: 700,
                        color
                    }}
                >
                    {value}
                </div>

            </div>

            <div
                style={{
                    fontSize: 34
                }}
            >
                {icon}
            </div>

        </div>

    );

};

export default SummaryCard;